<template>
    <v-data-table :headers="tableHeaders" :items="tableData" :items-per-page="6"
                  :loading="loading" :calculate-widths="true" @click:row="onApplyFilter">
        <template slot="body.append">
            <tr>
                <th>Total</th>
                <th>{{ totalMortalidade }}</th>
                <th>100%</th>
            </tr>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" x-small >
                        fas fa-filter
                    </v-icon>
                </template>
                <span> Utilizar como filtro os Lotes de Produção</span>
            </v-tooltip>
        </template>
    </v-data-table>
</template>
<script>
export default {
    name: 'MortalityCausesTable',
    computed:{
        tableHeaders() {
            return [
                {
                    text: 'Motivo',
                    value: 'dsMotivo',
                    sortable: false,
                    align: "start"
                },
                {
                    text: 'Quantidade',
                    value: 'nrQuantidade',
                    sortable: false,
                    align: "start"
                },
                {
                    text: 'Percentual',
                    value: 'peMortalidade',
                    sortable: false,
                    align: "start"
                },
                { 
                    text: '', 
                    value: 'actions', 
                    sortable: false,
                    align: "end"
                },
            ];
        }
    },
    methods: {
        onApplyFilter(item){
            this.$emit('apply', item.dsMotivo)
        }
    },
    props: {
        tableData: {},
        loading: Boolean,
        totalMortalidade: Number
    }
}
</script>
